import Component from '../colorz/Component';

import device from '../colorz/utils/device';

let UID = {
  _current: 0,
  getNew: function(){
    this._current++;
    return this._current;
  }
};

// Modify the :<pseudo_element> (like :-webkit-datetime-edit) of an element using JavaScript
// See http://mcgivery.com/htmlelement-pseudostyle-settingmodifying-before-and-after-in-javascript/
HTMLElement.prototype.pseudoStyle = function(element,prop,value){
  var _this = this;
  var _sheetId = "pseudoStyles";
  var _head = document.head || document.getElementsByTagName('head')[0];
  var _sheet = document.getElementById(_sheetId) || document.createElement('style');
  _sheet.id = _sheetId;
  var className = "pseudoStyle" + UID.getNew();
  
  _this.className +=  " "+className; 
  
  _sheet.innerHTML += "\n."+className+":"+element+"{"+prop+":"+value+"}";
  _head.appendChild(_sheet);
  return this;
};

module.exports = class Input extends Component {
  onInit( el, args) {
    // Initializations
    this.listenChange = this.listenChange.bind( this );
    this.listenFocus  = this.listenFocus.bind( this );

    this.el = el;
    this.inputs = this.el.querySelectorAll('.js-inputs');
    this.input  = this.el.querySelectorAll('.js-input');
    this.label  = this.el.querySelectorAll('.js-label');
  }

  onReady() {
    for (var i = 0; i < this.input.length; i++) {
      // console.log(this.input[i]);
      if ( this.input[i].value != '' ) {
        if (this.input[i].classList.contains('wpcf7-form-control')) { // spécifique Contact Form
          // console.log("onReady - input has class wpcf7-form-control !")
          this.input[i].parentNode.parentNode.classList.add('valueIn', 'transition-on');
        } else {
          // console.log("onReady - input has no class wpcf7-form-control !")
          this.input[i].parentNode.classList.add('valueIn', 'transition-on');
        }
      } else {
        if (this.input[i].classList.contains('wpcf7-form-control')) { // spécifique Contact Form
          // console.log("onReady - input has class wpcf7-form-control !")
          this.input[i].parentNode.parentNode.classList.remove('valueIn', 'transition-on');
        } else {
          // console.log("onReady - input has no class wpcf7-form-control !")
          this.input[i].parentNode.classList.remove('valueIn', 'transition-on');
        }
      }

      this.input[i].addEventListener( 'focusout', this.listenChange );
      this.input[i].addEventListener( device.pointerdown, this.listenFocus );
    }
  }

  listenChange(e) {
    if( e.currentTarget.value != '' ) {
      e.currentTarget.pseudoStyle(":-webkit-datetime-edit","color","black!important");
      if (e.currentTarget.classList.contains('wpcf7-form-control')) { // spécifique Contact Form
        // console.log("listenChange - input has class wpcf7-form-control !")
        e.currentTarget.parentNode.parentNode.classList.add('transition-on');
      } else {
        // console.log("listenChange - input has no class wpcf7-form-control !")
        e.currentTarget.parentNode.classList.add('transition-on');
      }
    } else {
      if (e.currentTarget.classList.contains('wpcf7-form-control')) { // spécifique Contact Form
        // console.log("listenChange - input has class wpcf7-form-control !")
        e.currentTarget.parentNode.parentNode.classList.remove('transition-on');
      } else {
        // console.log("listenChange - input has no class wpcf7-form-control !")
        e.currentTarget.parentNode.classList.remove('transition-on');
      }
    }
  }

  listenFocus(e) {
    if( e.currentTarget.value != '' ) {
      e.currentTarget.pseudoStyle(":-webkit-datetime-edit","color","black");
    }
  }
}